import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component, Fragment } from '@wordpress/element';
import { SelectControl, TextControl } from '@wordpress/components';
import { get, find, partial, isArray } from 'lodash';
import interpolateComponents from 'interpolate-components';
import classnames from 'classnames';
import { sprintf, __, _x } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import TextControlWithAffixes from '../text-control-with-affixes';
import { textContent } from './utils';

var NumberFilter =
/*#__PURE__*/
function (_Component) {
  _inherits(NumberFilter, _Component);

  function NumberFilter() {
    _classCallCheck(this, NumberFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberFilter).apply(this, arguments));
  }

  _createClass(NumberFilter, [{
    key: "getBetweenString",
    value: function getBetweenString() {
      return _x('{{rangeStart /}}{{span}} and {{/span}}{{rangeEnd /}}', 'Numerical range inputs arranged on a single line', 'woocommerce-admin');
    }
  }, {
    key: "getScreenReaderText",
    value: function getScreenReaderText(filter, config) {
      var currency = this.props.currency;
      var inputType = get(config, ['input', 'type'], 'number');
      var rule = find(config.rules, {
        value: filter.rule
      }) || {};

      var _ref = isArray(filter.value) ? filter.value : [filter.value],
          _ref2 = _slicedToArray(_ref, 2),
          rangeStart = _ref2[0],
          rangeEnd = _ref2[1]; // Return nothing if we're missing input(s)


      if (!rangeStart || 'between' === rule.value && !rangeEnd) {
        return '';
      }

      if ('currency' === inputType) {
        rangeStart = currency.formatCurrency(rangeStart);
        rangeEnd = currency.formatCurrency(rangeEnd);
      }

      var filterStr = rangeStart;

      if ('between' === rule.value) {
        filterStr = interpolateComponents({
          mixedString: this.getBetweenString(),
          components: {
            rangeStart: createElement(Fragment, null, rangeStart),
            rangeEnd: createElement(Fragment, null, rangeEnd),
            span: createElement(Fragment, null)
          }
        });
      }

      return textContent(interpolateComponents({
        mixedString: config.labels.title,
        components: {
          filter: createElement(Fragment, null, filterStr),
          rule: createElement(Fragment, null, rule.label)
        }
      }));
    }
  }, {
    key: "getFormControl",
    value: function getFormControl(_ref3) {
      var type = _ref3.type,
          value = _ref3.value,
          label = _ref3.label,
          onChange = _ref3.onChange,
          currencySymbol = _ref3.currencySymbol,
          symbolPosition = _ref3.symbolPosition;

      if ('currency' === type) {
        return 0 === symbolPosition.indexOf('right') ? createElement(TextControlWithAffixes, {
          suffix: createElement("span", {
            dangerouslySetInnerHTML: {
              __html: currencySymbol
            }
          }),
          className: "woocommerce-filters-advanced__input",
          type: "number",
          value: value || '',
          "aria-label": label,
          onChange: onChange
        }) : createElement(TextControlWithAffixes, {
          prefix: createElement("span", {
            dangerouslySetInnerHTML: {
              __html: currencySymbol
            }
          }),
          className: "woocommerce-filters-advanced__input",
          type: "number",
          value: value || '',
          "aria-label": label,
          onChange: onChange
        });
      }

      return createElement(TextControl, {
        className: "woocommerce-filters-advanced__input",
        type: "number",
        value: value || '',
        "aria-label": label,
        onChange: onChange
      });
    }
  }, {
    key: "getFilterInputs",
    value: function getFilterInputs() {
      var _this$props = this.props,
          config = _this$props.config,
          filter = _this$props.filter,
          onFilterChange = _this$props.onFilterChange,
          currency = _this$props.currency;
      var currencySymbol = currency.symbol,
          symbolPosition = currency.symbolPosition;
      var inputType = get(config, ['input', 'type'], 'number');

      if ('between' === filter.rule) {
        return this.getRangeInput();
      }

      var _ref4 = isArray(filter.value) ? filter.value : [filter.value],
          _ref5 = _slicedToArray(_ref4, 2),
          rangeStart = _ref5[0],
          rangeEnd = _ref5[1];

      if (Boolean(rangeEnd)) {
        // If there's a value for rangeEnd, we've just changed from "between"
        // to "less than" or "more than" and need to transition the value
        onFilterChange(filter.key, 'value', rangeStart || rangeEnd);
      }

      var labelFormat = '';

      if ('lessthan' === filter.rule) {
        /* eslint-disable-next-line max-len */

        /* translators: Sentence fragment, "maximum amount" refers to a numeric value the field must be less than. Screenshot for context: https://cloudup.com/cmv5CLyMPNQ */
        labelFormat = _x('%(field)s maximum amount', 'maximum value input', 'woocommerce-admin');
      } else {
        /* eslint-disable-next-line max-len */

        /* translators: Sentence fragment, "minimum amount" refers to a numeric value the field must be more than. Screenshot for context: https://cloudup.com/cmv5CLyMPNQ */
        labelFormat = _x('%(field)s minimum amount', 'minimum value input', 'woocommerce-admin');
      }

      return this.getFormControl({
        type: inputType,
        value: rangeStart || rangeEnd,
        label: sprintf(labelFormat, {
          field: get(config, ['labels', 'add'])
        }),
        onChange: partial(onFilterChange, filter.key, 'value'),
        currencySymbol: currencySymbol,
        symbolPosition: symbolPosition
      });
    }
  }, {
    key: "getRangeInput",
    value: function getRangeInput() {
      var _this$props2 = this.props,
          config = _this$props2.config,
          filter = _this$props2.filter,
          onFilterChange = _this$props2.onFilterChange,
          currency = _this$props2.currency;
      var currencySymbol = currency.symbol,
          symbolPosition = currency.symbolPosition;
      var inputType = get(config, ['input', 'type'], 'number');

      var _ref6 = isArray(filter.value) ? filter.value : [filter.value],
          _ref7 = _slicedToArray(_ref6, 2),
          rangeStart = _ref7[0],
          rangeEnd = _ref7[1];

      var rangeStartOnChange = function rangeStartOnChange(newRangeStart) {
        onFilterChange(filter.key, 'value', [newRangeStart, rangeEnd]);
      };

      var rangeEndOnChange = function rangeEndOnChange(newRangeEnd) {
        onFilterChange(filter.key, 'value', [rangeStart, newRangeEnd]);
      };

      return interpolateComponents({
        mixedString: this.getBetweenString(),
        components: {
          rangeStart: this.getFormControl({
            type: inputType,
            value: rangeStart || '',
            label: sprintf(
            /* eslint-disable-next-line max-len */

            /* translators: Sentence fragment, "range start" refers to the first of two numeric values the field must be between. Screenshot for context: https://cloudup.com/cmv5CLyMPNQ */
            __('%(field)s range start', 'woocommerce-admin'), {
              field: get(config, ['labels', 'add'])
            }),
            onChange: rangeStartOnChange,
            currencySymbol: currencySymbol,
            symbolPosition: symbolPosition
          }),
          rangeEnd: this.getFormControl({
            type: inputType,
            value: rangeEnd || '',
            label: sprintf(
            /* eslint-disable-next-line max-len */

            /* translators: Sentence fragment, "range end" refers to the second of two numeric values the field must be between. Screenshot for context: https://cloudup.com/cmv5CLyMPNQ */
            __('%(field)s range end', 'woocommerce-admin'), {
              field: get(config, ['labels', 'add'])
            }),
            onChange: rangeEndOnChange,
            currencySymbol: currencySymbol,
            symbolPosition: symbolPosition
          }),
          span: createElement("span", {
            className: "separator"
          })
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          config = _this$props3.config,
          filter = _this$props3.filter,
          onFilterChange = _this$props3.onFilterChange,
          isEnglish = _this$props3.isEnglish;
      var key = filter.key,
          rule = filter.rule;
      var labels = config.labels,
          rules = config.rules;
      var children = interpolateComponents({
        mixedString: labels.title,
        components: {
          title: createElement("span", {
            className: className
          }),
          rule: createElement(SelectControl, {
            className: classnames(className, 'woocommerce-filters-advanced__rule'),
            options: rules,
            value: rule,
            onChange: partial(onFilterChange, key, 'rule'),
            "aria-label": labels.rule
          }),
          filter: createElement("div", {
            className: classnames(className, 'woocommerce-filters-advanced__input-range', {
              'is-between': 'between' === rule
            })
          }, this.getFilterInputs())
        }
      });
      var screenReaderText = this.getScreenReaderText(filter, config);
      /*eslint-disable jsx-a11y/no-noninteractive-tabindex*/

      return createElement("fieldset", {
        className: "woocommerce-filters-advanced__line-item",
        tabIndex: "0"
      }, createElement("legend", {
        className: "screen-reader-text"
      }, labels.add || ''), createElement("div", {
        className: classnames('woocommerce-filters-advanced__fieldset', {
          'is-english': isEnglish
        })
      }, children), screenReaderText && createElement("span", {
        className: "screen-reader-text"
      }, screenReaderText));
      /*eslint-enable jsx-a11y/no-noninteractive-tabindex*/
    }
  }]);

  return NumberFilter;
}(Component);

export default NumberFilter;
//# sourceMappingURL=number-filter.js.map